
<div class="sale-profile">
  <spinner v-if="!loaded" />

  <template v-else>
    <div class="top">
      <align flex>
        <div>
          <icon-button
            tooltip="Close card"
            icon="close"
            @click="close"
          />
        </div>

        <align small-gap>
          <verified-icon
            v-if="sale.cardId || sale.memberVerified"
            v-tooltip="{ content: 'Verified Sale', delay: { show: 1500, hide: 100 }, placement: 'bottom' }"
          />

          <icon-button
            v-if="isStaff && !sale.cardId"
            tooltip="Add to Ladder"
            icon="add_circle"
            @click="adminAddCard"
          />

          <icon-button
            tooltip="Add to Collection"
            icon="bookmark_add"
            @click="addToCollection"
          />

          <icon-button
            v-if="showViewSaleLink"
            tooltip="View sale"
            icon="launch"
            @click="openSale"
          />

          <icon-button
            v-if="isStaff && sale.platform === 'eBay'"
            icon="pageview"
            tooltip="View sale on Terapeak Research"
            @click.stop.prevent="viewTerapeak"
          />

          <icon-button
            v-if="isStaff && viewSalesOptions.length"
            tooltip="Remove Graded Profile Info"
            icon="remove_circle_outline"
            @click="adminRemoveGradedInfo(sale.itemId)"
          />

          <icon-button
            v-if="isStaff"
            tooltip="Edit Sale"
            icon="edit"
            @click="editSale"
          />

          <icon-button
            v-if="isStaff && !sale.cardId"
            tooltip="Delete sale"
            icon="delete_outline"
            @click.stop.prevent="adminDeleteSale(sale)"
          />
        </align>
      </align>
    </div>

    <section class="details">
      <div v-if="sale.image" class="image-container" @click.stop.prevent="showFullscreenImage = true">
        <img :src="sale.image" :alt="sale.title" />
      </div>

      <div class="stats">
        <div class="platform-text">
          <span>{{ platform }}</span><span v-if="sale.seller"> - {{ sale.seller }}</span>
        </div>

        <h5>{{ sale.title }}</h5>

        <section class="stats-grid">
          <stat-item
            label="Sold Price"
            :value="$filters.currency(sale.price, { full: true })"
          />

          <stat-item label="Sold Date" :value="$filters.date(sale.date)" />

          <value-display
            v-if="showValueDisplay"
            subtle
            :loading="loadingEstimateValue"
            :confidence="guideValue.confidence"
            :value="guideValue.value"
            :blur="guideValue.confidence === 1"
          />

          <stat-item label="Listing Type" :value="listingType" />

          <stat-item
            v-if="showPop"
            label="Pop"
            :value="populationValue"
            :has-empty-value="!populationValue"
          >
            <template #after>
              <icon-button
                class="pop-report"
                icon="menu_book"
                tooltip="View in depth population report"
                @click="showPopData"
              />
            </template>
          </stat-item>

          <stat-item v-if="sale.feedback != null" label="Feedback" :value="$filters.number(sale.feedback)" />
        </section>

        <button-dropdown
          v-if="viewSalesOptions.length"
          label="View Sales of this Card"
          align="left"
          kind="secondary"
          block
          :options="viewSalesOptions"
          @click="handleViewSales"
        />
      </div>
    </section>

    <section v-if="card && sale.cardId" class="sale-profile-section">
      <align flex class="ladder-card-header">
        <h4 class="secondary-font">
          Ladder Card
        </h4>

        <icon-button
          v-if="isStaff"
          icon="delete"
          tooltip="Remove Sale from Verified Profile"
          :loading="removingLadderCard"
          @click="removeLadderCard"
        />
      </align>

      <div class="ladder-container">
        <card-list-item
          :card="card"
          :fields="['currentValue']"
          :to="{ query: ladderCardQuery }"
          as="router-link"
        />
      </div>
    </section>

    <section v-if="profile" class="sale-profile-section">
      <h4 class="secondary-font">
        Profile
      </h4>

      <div class="profile-item-container" @click="openProfile">
        <profile-list-item :profile="profile" />
      </div>
    </section>

    <section v-if="index" class="sale-profile-section">
      <align flex class="ladder-card-header">
        <h4 class="secondary-font">
          Index
        </h4>

        <icon-button
          v-if="isStaff && !sale.cardId"
          icon="edit"
          tooltip="Manually set index on this sale"
          @click="showIndexEditor = !showIndexEditor"
        />
      </align>

      <index-search
        v-if="showIndexEditor"
        @selectPlayer="setPlayerIndex"
        @selectIndex="setCategoryIndex"
      />

      <div class="index-item-container" @click="openIndex">
        <index-list-item :index="index" />
      </div>
    </section>

    <section v-if="isStaff" class="sale-profile-section verify">
      <card-search
        v-if="!sale.cardId"
        include-hidden
        placeholder="Assign to a verified card"
        @select="adminVerifySale"
      />

      <br v-if="!sale.cardId" />

      <btn
        :loading="refreshingProfileInfo"
        loading-text="Refreshing"
        block
        kind="secondary"
        @click="refreshProfileInfo"
      >
        Refresh Profile Info
      </btn>
    </section>

    <section v-if="sale.notes" class="sale-profile-section notes">
      <h4 class="secondary-font">
        Notes
      </h4>
      <p>{{ sale.notes }}</p>
    </section>
  </template>

  <fullscreen-image
    :show="showFullscreenImage"
    :image="sale.originalImage || sale.image"
    :label="sale.title"
    @hide="showFullscreenImage = false"
  />
</div>
